import { createSelector, createSlice } from '@reduxjs/toolkit';

const uislice = createSlice({
    name: 'uislice',
    initialState: {
        isNavigationItemHover: false,
        isShowCookieBanner: true,
    },
    reducers: {
        setNavigationItemHover: (state, action) => {
            state.isNavigationItemHover = action.payload;
        },
        setIsShowCookieBanner: (state, action) => {
            state.isShowCookieBanner = action.payload;
        },
    },
});

export const selectIsNavigationItemHover = createSelector([state => state.ui], data => data.isNavigationItemHover);

export const selectIsShowCookieBanner = createSelector([state => state.ui], data => data.isShowCookieBanner);

export const { setNavigationItemHover, setIsShowCookieBanner } = uislice.actions;

export default uislice.reducer;
